import React from "react";
import { Wallet, Landmark, CreditCard } from "lucide-react";
import { formatMXN } from "../../lib/api";

const ICONS = {
  efectivo: Wallet,
  banco: Landmark,
  tarjeta: CreditCard,
};

const LABELS = {
  efectivo: "Efectivo",
  banco: "Banco",
  tarjeta: "Tarjeta",
};

export default function AccountCard({ account, testid }) {
  const Icon = ICONS[account.type] || Wallet;
  const isNegative = Number(account.balance) < 0;
  return (
    <div
      className="rounded-3xl bg-white border border-line/70 shadow-card p-5 flex items-center gap-4 transition-all hover:-translate-y-0.5 hover:shadow-cardHover"
      data-testid={testid}
    >
      <div className="h-12 w-12 rounded-2xl bg-sage-50 text-sage-900 flex items-center justify-center shrink-0">
        <Icon size={22} strokeWidth={1.8} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-sage-700">
          {LABELS[account.type] || account.type}
        </p>
        <p className="font-display font-bold text-lg text-ink truncate">{account.name}</p>
      </div>
      <p
        className={`font-display font-extrabold text-lg tabular ${
          isNegative ? "text-clay" : "text-ink"
        }`}
      >
        {formatMXN(account.balance)}
      </p>
    </div>
  );
}
